import { featureBlocks } from "@/mocks/home";

export default function FeatureSection() {
  return (
    <section className="border-t border-background-200 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-5">
            <span className="text-xs font-medium uppercase tracking-widest text-primary-600">
              平台概览
            </span>
            <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">
              进入后可以看到什么
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              登录进入平台后，内容按影视、综艺、动漫、直播等分区组织，
              并支持清晰度切换与跨端记录同步。下面是一些常见的功能与栏目说明，
              方便你在进去之后快速上手。
            </p>

            <div className="mt-6 overflow-hidden rounded-2xl border border-background-200 bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20living%20room%20scene%20with%20a%20large%20smart%20TV%20showing%20a%20colorful%20video%20catalog%20interface%20and%20a%20warm%20orange%20accent%20lighting%20atmosphere%2C%20cozy%20minimal%20interior%2C%20cinematic%20warm%20tones%2C%20clean%20editorial%20photography&width=1000&height=720&seq=video51-feature-1&orientation=landscape"
                alt="在客厅电视上浏览视频内容的场景示意"
                className="h-56 w-full object-top md:h-64"
              />
              <div className="flex items-center gap-3 p-5">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                  <i className="ri-tv-2-line text-xl" aria-hidden="true"></i>
                </span>
                <p className="text-sm text-foreground-700">
                  大屏端与手机端使用同一账号，收藏与观看进度自动保持一致。
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-5">
              {featureBlocks.map((block) => (
                <div
                  key={block.title}
                  className="rounded-xl border border-background-200 bg-background-100 p-5 transition-colors hover:border-accent-300 hover:bg-background-50 md:p-6"
                >
                  <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                    <i className={`${block.icon} text-xl`} aria-hidden="true"></i>
                  </span>
                  <h3 className="mt-4 font-heading text-base text-foreground-950">
                    {block.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-700">{block.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}